import React, { useState, Suspense } from 'react';
import { ImageContainer } from './CreateImage.styles';
import { AuthCheckAdmin } from '../../../Utils/AuthCheck/AdminCheck.auth';
import { httpCreateImage } from '../../../Hooks/admin/admin.post.hooks';
import imageCompression from 'browser-image-compression';
import HelmetHelper from '../../../Components/PageHelmet/HelmetHelper.component';
import {
  SubmitContainer,
  TopSubmit,
  BottomSubmit,
  FormBackground,
} from '../CreateForm.styles';

const LogoInput = React.lazy(
  () => import('../../../Components/Form/LogoInput')
);
const PrimaryButtonComponent = React.lazy(
  () =>
    import('../../../Components/Buttons/PrimaryButton/PrimaryButton.component')
);
const BreadCrumbs = React.lazy(
  () => import('../../../Components/Breadcrumbs/BreadcrumbsComponent.component')
);
const DisplayAllImages = React.lazy(
  () => import('./DisplayAllImages.component')
);

const CreateImage = () => {
  const [image, setImage] = useState();
  const [status, setStatus] = useState('');

  const submitImage = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    if (image) {
      setStatus('Preparing data');
      try {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 800,
          useWebWorker: true,
        };
        const compressedImage = await imageCompression(image, options);
        const imageName = compressedImage.name.replace(/\s+/g, '_');
        const imageFile = new File(
          [compressedImage],
          imageName.replace(/\s+/g, '_'),
          {
            type: compressedImage.type,
          }
        );
        formData.append('image', imageFile);
        formData.append('name', imageName);
        setStatus('Sending Data');
        let res = await httpCreateImage(formData);
        let data = await res.json();
        if (res.ok) {
          setStatus(data.msg || 'Image has been uploaded');
        } else {
          setStatus(data.msg || 'Image has not been uploaded');
        }
      } catch (err) {
        setStatus('Error occurred', err);
      }
    }
  };

  return (
    <AuthCheckAdmin>
      <HelmetHelper
        title="Upload Course Image"
        description="Form for creating an image"
      />
      <ImageContainer>
        <Suspense fallback={<p>Loading breadcrumbs...</p>}>
          <BreadCrumbs
            one="Admin Dashboard"
            oneLink="/admin"
            two="Upload Image"
          />
        </Suspense>
        <h2>Upload Course Image to S3 Bucket</h2>
        <FormBackground>
          <h4>Upload an image</h4>
          {/* <form> */}
          <Suspense fallback={<p>Loading logo input...</p>}>
            <LogoInput
              title="Current Image:  "
              image={image}
              setImage={setImage}
              containerClassName="formInputUnderline"
            />
          </Suspense>
          <SubmitContainer>
            <TopSubmit>
              {status.length > 0 && <p className="result">{status}</p>}
            </TopSubmit>
            <BottomSubmit>
              <Suspense fallback={<p>Loading submit button...</p>}>
                <PrimaryButtonComponent
                  functionName={submitImage}
                  span="Upload Image"
                  disabled={!image}
                />
              </Suspense>
            </BottomSubmit>
          </SubmitContainer>
          {/* </form> */}
        </FormBackground>
        <Suspense fallback={<p>Loading images...</p>}>
          <DisplayAllImages />
        </Suspense>
      </ImageContainer>
    </AuthCheckAdmin>
  );
};

export default CreateImage;
